import { useTranslation } from '../../../../lib/i18n';
import { ELEMENT_KIND_KEYS, elementKind, ownerElementLabel, pagePath, sentReviewCountKey, type SentReviewComment } from '../../../../lib/site-review';
import styles from './SiteReviewMessage.module.css';

// The owner's own finished site review (contract §2.5), drawn as a compact card inside their bubble instead of the raw
// text the agent reads: two full URLs and CSS selectors per comment are noise to the person who wrote them. RENDER only —
// the stored message is unchanged, and a message that does not parse (`parseSentReview`) stays the plain bubble.
// The same card is iOS `SiteReviewViews` / Android's chat bubble, from the same parser.
export function SiteReviewMessage({ comments }: { comments: readonly SentReviewComment[] }) {
  const { t, i18n } = useTranslation();
  const count = t(sentReviewCountKey(comments.length, i18n.language), { count: comments.length });
  return (
    <div className={styles.card} data-testid="siteReviewMessage">
      <div className={`sym-type-small-medium ${styles.title}`}>
        {t('siteReview.sent.title')} · {count}
      </div>
      <ol className={styles.list}>
        {comments.map((c, i) => (
          <li key={i} className={styles.item}>
            <span dir="auto" className={styles.comment}>
              {i + 1}. {c.comment}
            </span>
            <span dir="auto" className={`sym-p3 ${styles.meta}`}>
              {ownerElementLabel(t(ELEMENT_KIND_KEYS[elementKind(c.tag)]), c.text)} · {pagePath(c.pageUrl)}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
